import {inject, Injectable} from '@angular/core';
import {AlertController, LoadingController, ToastController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  alert = inject(AlertController)
  toast = inject(ToastController)

  constructor(
    private loadingCtrl: LoadingController,
  ) {
  }

  presentLoading(message: string = '', cssClass: string = 'default-loading') {
    return this.loadingCtrl.create({
      message,
      spinner: 'crescent',
      cssClass,
    });
  }

  async openConfirmAlert(
    title: string,
    message: string,
    TrueButtonText: string,
    danger = false,
    onDidDismiss = false
  ): Promise<boolean> {
    const CANCEL_TEXT = 'キャンセル';
    let resolveFunction: (confirm: boolean) => void;
    const promise = new Promise<boolean>((resolve) => {
      resolveFunction = resolve;
    });
    const inner = message;
    const alert = await this.alert.create({
      header: title,
      cssClass: 'alert-message',
      message: message,
      backdropDismiss: false,
      mode: 'ios',
      buttons: [
        {
          text: CANCEL_TEXT,
          handler: () => resolveFunction(false),
          cssClass: 'alert-cancel-button'
        },
        {
          text: TrueButtonText,
          handler: () => resolveFunction(true),
          cssClass: danger ? 'alert-NegativeButton' : ''
        }
      ]
    });
    await alert.present();
    if (onDidDismiss) await alert.onDidDismiss();
    return promise;
  }

  async openAlert(headerText: string, dispText: string, buttonText: string) {
    const alert = await this.alert.create({
      header: headerText,
      message: dispText,
      buttons: [buttonText],
      mode: 'ios',
      backdropDismiss: false
    });
    await alert.present();
    return alert;
  }

  async presentToast(toastmessage: string, killtime = 3000, position: 'top' | 'bottom' | 'middle' = 'bottom') {
    const toast = await this.toast.create({message: toastmessage, duration: killtime, position});
    await toast.present();
  }

  /**
   * 画像ファイルをwebpに変換
   * @param inputFile
   */
  convertImageToWebPFile(inputFile: File | null | undefined): Promise<File> {
    return new Promise((resolve, reject) => {
      if (!inputFile) {
        return reject(new Error('有効なファイルが選択されていません'));
      }

      const img = new Image();
      const reader = new FileReader();

      reader.onload = (event) => {
        const result = event.target?.result;
        if (!result) {
          return reject(new Error('画像の読み込みに失敗しました'));
        }
        img.src = result as string;
      };

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          return reject(new Error('Canvas context の取得に失敗しました'));
        }

        ctx.drawImage(img, 0, 0);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              return reject(new Error('WebP への変換に失敗しました'));
            }

            const webpFile = new File(
              [blob],
              inputFile.name.replace(/\.\w+$/, '.webp'),
              {type: 'image/webp'}
            );
            resolve(webpFile);
          },
          'image/webp',
          0.8
        );
      };

      img.onerror = () => reject(new Error('画像の読み込み中にエラーが発生しました'));

      reader.readAsDataURL(inputFile);
    });
  }

}
